<script>
	import {onMount,onDestroy} from 'svelte'
	import Tailwindcss from '../components/Tailwindcss.svelte'
	
	import Router from '../router/Router.svelte'
	import Link from '../router/Link.svelte'
	import {routes} from './routes'
	import Splash from './components/Splash.svelte'
	import Authenticate from '../components/Authenticate.svelte'
	import Header from './components/Header.svelte'
	import Footer from './components/Footer.svelte'
	
	import {locale,language} from '../languages.js'
	import {getResource} from '../service'
	import 'notyf/notyf.min.css';


	//checking for authentication 
	getResource('profile')
	
	
	const routerParams = {
		routes,
		defaultRoute:'home',
		header:Header,
		footer:Footer
	}


</script>
<svelte:head>
	<title>{ $language.app_title }</title>
</svelte:head>
<Tailwindcss/>
<Splash duration={4000}>		
	<Authenticate>
	<div class="container mx-auto h-screen w-screen"  class:rtl={$locale == 'ar'}>				
		<div id="app" >			
			<Router {...routerParams}/>		
		</div>
	</div>
	
	</Authenticate>
</Splash>

<style >
	.rtl  {
		direction: rtl;
	}
	
	#app {
        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: auto 1fr 50px;
        height: 100%;
    }
</style>




